<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row">
        <div class="col">
          <app-nav-profile />
        </div>
      </div>
      <div class="row mb-12">
        <div class="col">
          <div class="content-card mb-4">
            <div class="content-card mb-4">
              <div class="content-card-title">
                บัญชีผู้ใช้
              </div>
              <div class="content-card-body">
                <form enctype="multipart/form-data" @submit.prevent="onSubmit" accept-charset="utf-8">
                  <input type="hidden" name="csrf_token" value="994f0f39b33bf16e2f6137d7acaeb03a" />
                  <input type="hidden" name="updateprofile" value="1" />
                  <div class="row">
                    <div class="col-12 col-md-12 col-lg-12">
                      <h5 class="">ตั้งค่าบัญชีผู้ใช้</h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="row form-special ">
                        <label class="form-label">ชื่อผู้ใช้งาน</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-icon fa-regular fa-user"></i></span>
                          <input type="text" class="form-control" v-model="getUser" readonly="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="row form-special ">
                        <label class="form-label">ชื่อจริง</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-solid fa-bars"></i></span>
                          <input type="text" class="form-control" value="" v-model="firstName" />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="row form-special">
                        <label class="form-label">นามสกุล</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-solid fa-bars"></i></span>
                          <input type="text" class="form-control" value="" v-model="lastName" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="row form-special ">
                        <label class="form-label">ไลน์ ไอดี</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-brands fa-line"></i></span>
                          <input type="text" class="form-control" value=""  v-model="lineId" />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <label for="birth-date" class="form-label">วัน/เดือน/ปี เกิด</label>
                      <div class="form-row" id="birth-date">
                        <div class="form-group custom-select-wrapper">
                          <select name="day" class="form-control" v-model="day" aria-required="true" required>
                            <option value="">วัน</option>
                            <option v-for="d in 31" :key="d" :value="formatNumber(d)">{{ formatNumber(d) }}</option>
                          </select>
                        </div>
                        <div class="form-group custom-select-wrapper">
                          <select name="month" class="form-control" v-model="month" aria-required="true" required>
                            <option value="">เดือน</option>
                            <option v-for="(m, index) in months" :key="index" :value="formatNumber(index + 1)">{{ m }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group custom-select-wrapper">
                          <select name="year" class="form-control" v-model="year" aria-required="true" required>
                            <option value="">ปี</option>
                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="row form-special ">
                        <label class="form-label">อีเมล์</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-solid fa-envelope"></i></span>
                          <input type="email" name="email" id="email" v-model="email" class="form-control"
                            required="" />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="row form-special ">
                        <label class="form-label">เบอร์โทรศัพท์</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <span class="input-group-text"><i class="fa-icon fa-regular fa-phone"></i></span>
                          <input type="tel" class="form-control" v-model="phone" readonly="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-12 col-md-12 col-lg-12">
                      <h5 class="mb-0">จัดการรหัสผ่าน</h5>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 col-md-12 col-lg-12">
                      <div class="row form-special ">
                        <label class="form-label">รหัสผ่านเดิม</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <input type="tel" class="form-control" v-model="presentPassword" />
                          <span class="input-group-text"><i class="fa-solid fa-key"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12 col-md-12 col-lg-12">
                      <div class="row form-special ">
                        <label class="form-label">รหัสผ่านใหม่</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <input type="tel" class="form-control" v-model="newPassword" />
                          <span class="input-group-text"><i class="fa-solid fa-repeat"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-">
                    <div class="col-12 col-md-12 col-lg-12">
                      <div class="row form-special ">
                        <label class="form-label">ยืนยันรหัสผ่านใหม่</label>
                        <div class="input-group input-group-sm input-group-merge" id="phone">
                          <input type="tel" class="form-control" v-model="confirmPassword" />
                          <span class="input-group-text"><i class="fa-solid fa-repeat"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-12 col-md-12 col-lg-12">
                      <button class="btn btn-success btn-block w-100" type="submit">
                        <i class="fa-regular fa-floppy-disk"></i>&nbsp; บันทึก
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="push"></div>
    </div>
  </div>
</template>

<script>
import menu_profile from '@/components/sakha/menu_profile'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { updateUserProfileService } from '@/services'
export default {
  data: () => {
    return {
      url: require('@/assets/images/userprofile.png'),
      day: null,
      month: null,
      year: null,
      presentPassword: null,
      newPassword: null,
      confirmPassword: null,
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      lineId: null,
      months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      years: Array.from({ length: 100 }, (_, i) => 2564 - i) // Generate years from 2564 to 2465
    }
  },
  components: {
    'app-nav-profile': menu_profile
  },
  async created () {
    try {
      await this.prepareData()
    } catch (error) {
      this.setLoading(false)
    }
  },
  methods: {
    ...mapActions(['getProfileInfo', 'setLoading', 'openInfoPopup']),
    async onSubmit () {
      try {
        this.setLoading(true)
        const resp = await updateUserProfileService({
          dateOfBirth: moment(
            `${this.day}/${this.month}/${this.year}`,
            'DD/MM/YYYY'
          ),
          ...(this.getProfile.email !== this.email && { email: this.email }),
          ...(this.newPassword &&
            { old_password: this.presentPassword, password: this.newPassword }),
          ...(this.getProfile.first_name !== this.firstName && { first_name: this.firstName }),
          ...(this.getProfile.last_name !== this.lastName && { last_name: this.lastName }),
          ...(this.getProfile.line_id !== this.lineId && { line_id: this.lineId })
        })

        if (resp.status_code === 'SUCCESS') {
          await this.getProfileInfo()
          await this.prepareData()
          await this.openInfoPopup()
        }
        window.scrollTo(0, 0)
        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
      }
    },
    async prepareData () {
      await this.setLoading(true)
      await this.getProfileInfo()
      this.email = await this.getProfile.email
      this.firstName = await this.getProfile.first_name
      this.lastName = await this.getProfile.last_name
      this.phone = await this.getProfile.phone_number
      this.lineId = await this.getProfile.line_id
      const birthday = await this.getProfile.birthday.toString()
      const spliter = birthday.split('-')
      this.day = await spliter[2]
      this.month = await spliter[1]
      this.year = await spliter[0]
      await this.setLoading(false)
    },
    formatNumber (n) {
      return n < 10 ? '0' + n : n
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    getUser () {
      return this.$store.getters?.getUsername?.toString()
    }
  }
}
</script>
<style>
.custom-select-wrapper {
  position: relative;

}

.custom-select-wrapper select {

  padding-right: 30px;
  /* Make space for the caret */
}

.custom-select-wrapper::after {
  content: '▼';
  /* Add down arrow */
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  /* Prevent arrow from blocking clicks */
}

.form-row {
  display: flex;
  /* Align elements in a row */
  gap: 10px;
  /* Space between the dropdowns */
}

.form-group {
  flex: 1;
  /* Make the dropdowns flexible and of equal width */
}

.form-control {
  height: 40px;
  /* Set a consistent height for the dropdowns */
  padding: 5px 10px;
  /* Ensure proper padding inside the dropdowns */
  border-radius: 4px;
  /* Add border-radius for a smoother look */
  box-sizing: border-box;
  /* Prevent padding from affecting width */
}
</style>
